<script>
	/* IMPORT: SVELTE/KIT */
	import { onMount, tick } from 'svelte';
	import { page } from '$app/stores';
	import { browser } from '$app/environment';
  
	/* IMPORT: 3RD-PARTY */
	import { storeVideo } from '$lib/script/store.js';
	import { scrollToAnchor } from '$lib/script/scroll.js';
	import SiteMain from '$lib/component/site/site-main.svelte';
	import HeadLegacy from '$lib/component/page/head-legacy.svelte';
	/* Svelte Methods */

	let videoActive = null;
	let videoActiveId = 'j_7OX-oMykI';

	const videoCat = ['All', 'Automotive', 'Small Engine', 'Firearms', 'Aviation', 'Locomotive', 'Power Sports'];
	const videoList = $storeVideo;
	let videoListByCat = null;
	const videoListUpdate = ( _cat ) => 
	{

		videoListByCat = [] = videoList.filter( ( _entry, _i ) => 
		{
			if ( _cat === videoCat[0] || _entry.cat.includes( _cat ) ) 
			{
				return _entry ;
			}

		});

		paginateMax = ( ( videoListByCat.length + 1 ) < paginatePer ) ? 1 : Math.ceil( videoListByCat.length / paginatePer );

		videoListByCat = videoListByCat.filter( ( _entry, _i ) => 
		{
			
			if ( _cat === videoCat[0] || _entry.cat.includes( _cat ) ) 
			{
				const min = ( ( paginate - 1 ) * paginatePer + 1 );
				const max = (( ( paginate - 1 ) * paginatePer) + paginatePer );
				if ( ( _i + 1 ) >= min && ( _i + 1 ) <= max )
				{
					return _entry;
				}
			}
		});

		return videoListByCat;
	}

	const videoInit = ( _args ) =>
	{
		let videoActiveIdQueryString = _args?.videoId ?? $page.url.searchParams.get('video-id');
	
		videoActiveId = ( typeof videoActiveIdQueryString === 'string' && videoActiveIdQueryString !== '' ) ? videoActiveIdQueryString : videoActiveId;
		
		videoActive = $storeVideo.filter( ( _entry, _i ) => 
		{ 
			if ( _entry.ytId === videoActiveId ) return _entry;
		});

	}

	const videoAnchorInit = () =>
	{
		let init = true ;
		window.addEventListener( 'scroll', () => 
		{
			if ( !init ) return;

			document.querySelectorAll( '#videoArchive a' ).forEach( ( _entry, _i ) => 
			{
				_entry.addEventListener( 'click', ( _event ) => 
				{
					_event.preventDefault();
					history.pushState({}, '', _event.currentTarget.getAttribute( 'href' ) );
					videoInit({ videoId: _event.currentTarget.getAttribute( 'href' ).split( '=' )[1] });
					scrollToAnchor( document.querySelector( `[name=videoContent]` ), 0, null );

				});
			});

			init = false;

		});
	}

	let paginateCat = videoCat[0];
   let paginate = 1;
	let paginateMin = 1;
	let paginateMax = 1;
	let paginatePer = 12;
	

	let paginateNext = null;
	let paginatePrev = null;
	let paginateList = null;
	let paginateCatList = null;
	

	const paginateUpdate = () =>
	{
		// Handle paginate next clicks
		paginateNext.addEventListener( 'click', ( _event ) => 
		{
			paginate = ( paginate < paginateMax ) ? paginate+1 : paginageMax;
			videoListUpdate( paginateCat );
			window.scrollTo(0,0);
			ga('send', 'Video', 'Click', 'Pagination - Next');
		});

		// Handle paginate prev clicks
		paginatePrev.addEventListener( 'click', ( _event ) => 
		{
			paginate = ( paginate > paginateMin ) ? paginate-1 : paginateMin;
			videoListUpdate( paginateCat );
			window.scrollTo(0,0);
			ga('send', 'Video', 'Click', 'Pagination - Prev');

		});

		// Handle Cat change clicks
		let paginateCatListLinks = paginateCatList.querySelectorAll( 'li a' );
		
		Array.from( paginateCatListLinks, ( _entryCat, _i) => 
		{
			_entryCat.addEventListener( 'click', ( _entryCatEvent ) => 
			{
				_entryCatEvent.preventDefault();

				Array.from( paginateCatListLinks, ( _entryCatActive, _j ) => 
				{
					_entryCatActive.parentNode.classList.remove('active');
				});

				_entryCatEvent.currentTarget.parentNode.classList.add('active');

				paginate = 1;
				paginateCat = _entryCatEvent.currentTarget.dataset.cat;
				videoListUpdate( paginateCat );
				paginateUpdateLinks();
				ga('send', 'Video', 'Click', `Pagination - Page ${ paginateCat }`);
			});

		});

		videoListUpdate( paginateCat );
		paginateUpdateLinks();
	}

	const paginateUpdateLinks = () =>
	{		
		const tempTimeout = setTimeout( () => {

			let paginateListLinks = paginateList.querySelectorAll( 'li a' ); 
			
			Array.from( paginateListLinks, ( _entryPage, _i) => 
			{
				_entryPage.addEventListener( 'click', ( _entryPageEvent ) => 
				{
					_entryPageEvent.preventDefault();

					Array.from( paginateListLinks, ( _entryPageActive, _j ) => 
					{
						if ( _entryPageActive !== _entryPageEvent.currentTarget ) _entryPageActive.parentNode.classList.remove('active');
						if ( _entryPageActive === _entryPageEvent.currentTarget ) _entryPageActive.parentNode.classList.add('active');
					});

					if ( _entryPageEvent.currentTarget.dataset.page > paginate ) paginateNext.dispatchEvent( new Event('click') );
					if ( _entryPageEvent.currentTarget.dataset.page < paginate ) paginatePrev.dispatchEvent( new Event('click') );
					
					ga('send', 'Video', 'Click', `Pagination - Page ${ paginatePage }`);
				});

			});

			clearTimeout( tempTimeout );
			
		}, 100);
	}

	$: paginateCatList && paginateUpdate();
	$: videoListByCat && videoAnchorInit();
	$: $page.url && videoInit();
	// Handle readiness [ window, document, browser, storeGlobal, ...]
	
	onMount( async () => 
	{
	});

</script>

<svelte:head>

	<title>STORR's 2019 Baja 500 HIghlights | videos of zMAX working | zMAX Micro-lubricant</title>
	<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
	<meta name="keywords" content="zMAX, engine treatment, fuel treatment, transmission, CVT, Advance Auto, AutoZone, Oreillys, Walmart, Pepboys, fuel mileage, engine performance" />
	<meta name="description" content="Join STORR as they storm the border and take on the mighty Baja 500 (2019). Although this years race didn't lead to the victory we wanted, our perseverance and fight made for a great journey for the team. #BajaWinsAgain Purchase Shock Therapy products direct at www.ShockTherapyst.com Follow STORR (Shock Therapy Off Road Racing): Instagram @ShockTherapyOffRoadRacing Facebook #STORR | videos of zMAX working" />
	<meta name="google-signin-client_id" content="675431201748-qmdfi12pnm3ngaqp6t07tb623heb7kki.apps.googleusercontent.com">
	<meta name="medium" content="video" />
	<meta name="twitter:card" content="player" />
	<meta property="og:video" content="https://www.speedwaymotorsports.com/services/video/mediaplayer-5.9/player.swf?file=https://www.youtube.com/v/j_7OX-oMykI&amp;autostart=true&amp;skin=https://www.speedwaymotorsports.com/services/video/mediaplayer-5.9/glow.zip&amp;controlbar.position=over&amp;controlbar.idlehide=true" />
	<meta name="twitter:image" content="https://www.zmax.com/video/youtube/B51ECE5B-D88D-4598-12197C94E8FBCEC5.jpg" />
	<meta property="og:video:height" content="270" />
	<meta property="og:video:type" content="application/x-shockwave-flash" />
	<meta name="twitter:player:stream:content_type" content="video/mp4" />
	<meta property="og:site_name" content="zMAX" />
	<meta property="og:url" content="http://www.zmax.com/handler.cfm/template,video/cat_id,56381?med_id=1903688" />
	<meta name="twitter:player" content="https://www.zmax.com/handler.cfm/template,twitter-video-container/cat_id,56381/?id=3768706847" />
	<meta name="twitter:site" content="zMAX" />
	<meta name="twitter:player:height" content="270" />
	<meta property="og:video:width" content="480" />
	<meta property="og:image" content="http://www.zmax.com/video/youtube/B51ECE5B-D88D-4598-12197C94E8FBCEC5.jpg" />
	<meta name="twitter:player:stream" content="https://www.youtube.com/v/j_7OX-oMykI" />
	<meta name="twitter:player:width" content="480" />
	<meta property="og:description" content="Join STORR as they storm the border and take on the mighty Baja 500 (2019). Although this years race didn't lead to the victory we wanted, our perseverance and fight made for a great journey for the team. #BajaWinsAgain Purchase Shock Therapy products direct at www.ShockTherapyst.com Follow STORR (Shock Therapy Off Road Racing): Instagram @ShockTherapyOffRoadRacing Facebook #STORR | videos of zMAX working" />
	<meta property="og:title" content="STORR's 2019 Baja 500 HIghlights | videos of zMAX working | zMAX Micro-lubricant" />
	<meta name="twitter:description" content="Join STORR as they storm the border and take on the mighty Baja 500 (2019). Although this years race didn't lead to the victory we wanted, our perseverance and fight made for a great journey for the team. #BajaWinsAgain Purchase Shock Therapy products direct at www.ShockTherapyst.com Follow STORR (Shock Therapy Off Road Racing): Instagram @ShockTherapyOffRoadRacing Facebook #STORR" />
	<meta name="twitter:title" content="STORR's 2019 Baja 500 HIghlights" />
	<meta property="og:type" content="video.other" />
	<meta property="smi:rank" content="60" />

	<link rel="canonical" href={ $page.url } />

	<script type="text/javascript">
		var sectName = 'about';
		var catName = 'videos';
		var catID = '56381';
	</script>

	<HeadLegacy />

</svelte:head>

<SiteMain id='videos' class='videos'>
	<a name='videoContent' />
	<div id="pageBody">
		<div class="smi-container">
			<div id="pageContent">
				<div id="categoryHeader">
					<picture>
						<source srcset="https://www.zmax.com/images/category/video-image3_sm_600x150.jpg" media="(max-width: 480px)">
						<source srcset="https://www.zmax.com/images/category/video-image3_sm_800x150.jpg" media="(max-width: 768px)">
						<source srcset="https://www.zmax.com/images/category/video-image3_sm_1600x200.jpg">
						<img src="https://www.zmax.com/images/category/video-image3_sm_1600x200.jpg" alt="Videos Header" border="0">
					</picture>
					<h1>Videos</h1>
				</div>

				<div class="contentContainer">
					<div id="main">
						<div id="video" class="template">
							<div id="swfplayer">
								<!-- <div class="head">
									<h2><span>STORR's 2019 Baja 500 HIghlights</span></h2>
								</div> -->
								<div class="content" style="min-height:270px;">
									<div class="video-container" id="video-1903688"><iframe width="850" height="478" src={ `https://www.youtube.com/embed/${ videoActive[0].ytId }` } title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>
									<div class="description">
										<div class="title">{@html videoActive[0].title }</div>
										<div class="gallery">{@html videoActive[0].cat[0] }</div>
										<div class="published">{@html videoActive[0].date }</div>
										<div class="overview">
											{@html videoActive[0].description }
										</div>
									</div>
								</div>
							</div>
							<div id="channels">
								<ul bind:this={ paginateCatList }>
									{#if videoCat }
									{#each videoCat as _entry, _i }
										<li class={ paginateCat === _entry ? 'active' : '' } data-cat={ _entry }><a href={ `#` } title={ _entry } data-cat={ _entry }>{@html _entry }</a></li>
									{/each}
									{/if}
								</ul>
							</div>
							<div id="videoArchive">
								<ul class="equalheight">
									{#if videoListByCat }
									{#each videoListByCat as _entry, _i }
										<li data-page='1' data-cat={ _entry.cat.join(',') }>
											<div class="smi-thumbnail">
												<a href={ `/about/videos/?video-id=${  _entry.ytId }` } onClick={ `ga('send', 'Video', 'Click', '${ _entry.title }')` } title={ _entry.title  } >
													<img src={ _entry.cover } width="160" height="90" border="0" alt={ _entry.title }>
												</a>
											</div>
											<div class="details">
												<div class="title"><a href={ `/about/videos/?video-id=${  _entry.ytId }` } onClick={ `ga('send', 'Video', 'Click', '${ _entry.title }')` } title={ _entry.title  }>{@html _entry.title }</a></div>
												<div class="date">{@html _entry.date }</div>
											</div>
										</li>
									{/each}
									{/if}
								</ul>
							</div>
							<div id="pagination">
								<ul bind:this={ paginateList } class="pagination">
									<li bind:this={ paginatePrev } id="prev" class="disabled">
										<span>&laquo;</span>
									</li>
									{#if paginateMax }
									{#each {length: paginateMax} as _entry, _i}
										<li class={ paginate === (_i + 1) ? 'active' : '' } data-page={ _i + 1 }><a href="#" data-page={ _i + 1 }>{ _i + 1 }</a></li>
									{/each}
									{/if}
									<li  bind:this={ paginateNext } id="next">
										<!-- <a href="#" onClick="ga('send', 'Video', 'Click', 'Pagination - Next');> -->
											<span>&raquo;</span>
										<!-- </a> -->
									</li>
								</ul>
							</div>
						</div>
						<script type="text/javascript">
							// $( document ).ready( function ()
							// {
							// 	ga( 'send', 'Video', 'Watch', 'STORR\'s 2019 Baja 500 HIghlights (1903688)' );
							// } );
						</script>
					</div>
					<div id="left">
						<div id="left-container">
							<div class="sfContainer posLeft ">
								<div class="sfModule item1 sfLinks list " data-id="35495" data-name="sf-shop" id="csf64779">
									<div class="head"><a name="shop"></a>
										<h2><span>Shop</span></h2>
									</div>
									<div class="content">
										<ul id="sflink35495" class="links ">
											<li class="links1" id="csf64779_1" name="automotive" data-name="link-automotive" data-cat-id="56139">
												<div class="linkContainer">
													<div class="dataContainer">
														<div class="name"><a href="https://shopify.zmax.com/collections/automotive" onClick="ga('send', 'event', 'Links', 'Click', 'Automotive - https://shopify.zmax.com/collections/automotive');"><span>Automotive </span></a></div>
													</div>
												</div>
											</li>
											<li class="links1" id="csf64779_1" name="firearms" data-name="link-firearms" data-cat-id="56142">
												<div class="linkContainer">
													<div class="dataContainer">
														<div class="name"><a href="https://shopify.zmax.com/collections/firearms" onClick="ga('send', 'event', 'Links', 'Click', 'Firearms - https://shopify.zmax.com/collections/firearms');"><span>Firearms </span></a></div>
													</div>
												</div>
											</li>
											<li class="links1" id="csf64779_1" name="heavyduty" data-name="link-heavyduty" data-cat-id="56143">
												<div class="linkContainer">
													<div class="dataContainer">
														<div class="name"><a href="https://shopify.zmax.com/collections/heavy-duty" onClick="ga('send', 'event', 'Links', 'Click', 'Heavy Duty - https://shopify.zmax.com/collections/heavy-duty');"><span>Heavy Duty </span></a></div>
													</div>
												</div>
											</li>
											<li class="links1" id="csf64779_1" name="smallengine" data-name="link-smallengine" data-cat-id="56144">
												<div class="linkContainer">
													<div class="dataContainer">
														<div class="name"><a href="https://shopify.zmax.com/collections/small-engine" onClick="ga('send', 'event', 'Links', 'Click', 'Small Engine - https://shopify.zmax.com/collections/small-engine');"><span>Small Engine </span></a></div>
													</div>
												</div>
											</li>
											<li class="links1" id="csf64779_1" name="aviation" data-name="link-aviation" data-cat-id="56140">
												<div class="linkContainer">
													<div class="dataContainer">
														<div class="name"><a href="https://shopify.zmax.com/collections/aviation" onClick="ga('send', 'event', 'Links', 'Click', 'Aviation - https://shopify.zmax.com/collections/aviation');"><span>Aviation </span></a></div>
													</div>
												</div>
											</li>
											<li class="links1" id="csf64779_1" name="aerosolsappearance" data-name="link-aerosolsappearance" data-cat-id="56186">
												<div class="linkContainer">
													<div class="dataContainer">
														<div class="name"><a href="https://shopify.zmax.com/collections/aerosols-appearance" onClick="ga('send', 'event', 'Links', 'Click', 'Aerosols / Appearance - https://shopify.zmax.com/collections/aerosols-appearance');"><span>Aerosols / Appearance </span></a></div>
													</div>
												</div>
											</li>
											<li class="links1" id="csf64779_1" name="racingoil" data-name="link-racingoil" data-cat-id="56187">
												<div class="linkContainer">
													<div class="dataContainer">
														<div class="name"><a href="https://shopify.zmax.com/collections/racing-oil" onClick="ga('send', 'event', 'Links', 'Click', 'Racing Oil - https://shopify.zmax.com/collections/racing-oil');"><span>Racing Oil </span></a></div>
													</div>
												</div>
											</li>
											<li class="links1" id="csf64779_1" name="powersports" data-name="link-powersports" data-cat-id="56188">
												<div class="linkContainer">
													<div class="dataContainer">
														<div class="name"><a href="https://shopify.zmax.com/collections/power-sports" onClick="ga('send', 'event', 'Links', 'Click', 'Power Sports - https://shopify.zmax.com/collections/power-sports');"><span>Power Sports </span></a></div>
													</div>
												</div>
											</li>
											<li class="links1" id="csf64779_1" name="apparel" data-name="link-apparel" data-cat-id="56145">
												<div class="linkContainer">
													<div class="dataContainer">
														<div class="name"><a href="https://shopify.zmax.com/collections/apparel" onClick="ga('send', 'event', 'Links', 'Click', 'Apparel - https://shopify.zmax.com/collections/apparel');"><span>Apparel </span></a></div>
													</div>
												</div>
											</li>
										</ul>
									</div>
									<div class="foot"></div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</SiteMain>